import AuthUtil from '../redux/AuthUtil';
import { ACCESS } from '../components/global/Server/endpoints';

// Thin wrapper over the /access endpoints. Master-admin-only calls (requests,
// users, grant, revoke, deny) must only be invoked from the master-admin
// console — a 403 triggers AuthUtil's logout.
const accessApi = {
  // Any authenticated user
  requestAccess: (appId) => AuthUtil.postRequest(ACCESS.REQUEST, { appId }),
  myRequests: () => AuthUtil.getRequest(ACCESS.MY_REQUESTS),

  // Master-admin only
  listRequests: () => AuthUtil.getRequest(ACCESS.REQUESTS),
  allUsers: () => AuthUtil.getRequest(ACCESS.USERS),
  grant: (userId, appId) => AuthUtil.postRequest(ACCESS.GRANT, { userId, appId }),
  revoke: (userId, appId) => AuthUtil.postRequest(ACCESS.REVOKE, { userId, appId }),
  deny: (requestId) => AuthUtil.postRequest(ACCESS.DENY, { requestId }),
  createUser: (payload) => AuthUtil.postRequest(ACCESS.CREATE_USER, payload),
  updateUser: (payload) => AuthUtil.postRequest(ACCESS.UPDATE_USER, payload),
  deleteUser: (userId) => AuthUtil.postRequest(ACCESS.DELETE_USER, { userId }),
};

export default accessApi;
